import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const CallToAction: React.FC = () => {
  return (
    <section className="py-16 lg:py-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-white mb-6">
          Ready to Transform Your Laboratory Operations?
        </h2>
        <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
          Let's discuss how strategic leadership and operational excellence can drive measurable results for your organization.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="mailto:kendal@laboratory-leadership.com"
            className="inline-flex items-center space-x-2 px-8 py-4 bg-accent text-accent-foreground rounded-lg font-heading font-semibold text-lg hover:bg-accent/90 transition-all duration-300 hover:shadow-lg transform hover:-translate-y-0.5"
          >
            <Icon name="EnvelopeIcon" size={24} />
            <span>Contact Me</span>
          </a>
          
          <Link
            href="/experience-portfolio"
            className="inline-flex items-center space-x-2 px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-lg font-heading font-semibold text-lg hover:bg-white/20 transition-all duration-300 border border-white/20"
          >
            <Icon name="BriefcaseIcon" size={24} />
            <span>View Experience</span>
          </Link>
        </div>
        
        <div className="mt-12 pt-8 border-t border-white/20">
          <p className="text-white/80 text-sm mb-4">
            Connect with me on professional networks
          </p>
          <div className="flex justify-center space-x-4">
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center hover:bg-white/20 transition-all duration-300 border border-white/20"
              aria-label="LinkedIn Profile"
            >
              <Icon name="UserIcon" size={24} className="text-white" />
            </a>
            <a
              href="mailto:kendal@laboratory-leadership.com"
              className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center hover:bg-white/20 transition-all duration-300 border border-white/20"
              aria-label="Email Contact"
            >
              <Icon name="EnvelopeIcon" size={24} className="text-white" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;